import React, { useEffect, useState } from 'react'
import styles from './gridStyles.module.scss'
import {logo, photo, progress} from '../../../assets/img/dashCategoris'
import { arrowLeft, checkGreen, closeIcon, questionIcon } from '../../../assets/svg/dashboard/main'
import { useHistory, useParams } from 'react-router-dom'
import { eduIcon4 } from '../../../assets/img/dashCategoris'
import {
  BarChart,
  PieChart,
  Pie,
  Cell,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux'
import { getStudentsDetails, getPhoto } from '../../../actions/dashboard'
import { DASHBOARD_ENTITIES } from '../../../utils/const'
import { Check } from '../../../assets/NewDashboard'
import ReactTooltip from 'react-tooltip'
import { Input, Select } from '../../../assets/NewDashboard'
import { IoPerson } from 'react-icons/io5'
import { PiSortAscending, PiSortDescending } from "react-icons/pi";


const Details = ({spoMode}) => {
  
  const history = useHistory()
  const dispatch = useDispatch()
  const {id} = useParams()
  const { details } = useSelector(state => state.dashboard)
  
  const [filters, setFilters] = useState({fio: '', order_by: '', sort_order: 'asc'})

  useEffect(() => {
    dispatch(getStudentsDetails(id, spoMode, filters))
  }, [filters])

  const goTo = (link) => () => history.push(link) 
  
  const { info, students, total, bins } = details.students
  const { percent, name, score } = info
  const {min, max, options} = DASHBOARD_ENTITIES[spoMode ? 'spo' : 'high'].students

  return (
    <div>
      <section className={styles.detailsWrap}>
        <div onClick={goTo(`/dashboard_new/accreditation${spoMode ? '?level=spo' : ''}`)}>
          <div>{arrowLeft}</div>
          <h2>{name}</h2>
        </div>
        <div className={styles.dashBlock}>
          <section className={styles.firstSection}>
            <div>
              <div>
                <div>
                  <img src={eduIcon4} alt='о_О' />
                <p className={styles.pStyles}>Доля курсантов/<br/>слушателей, выполнивших<br/>большинство* заданий<br/>диагностической работы</p>
                </div>
              </div>
              <div>
                  <PieChartComponent percentage={percent} />
              </div>
            </div>
            <div>
              <div>
                <i data-tip='custom-jsx-tooltip' data-for="custom-jsx-tooltip">{questionIcon}</i>
                <ReactTooltip id="custom-jsx-tooltip" className={styles.tooltip}>
                  <p>Критериальное значение аккредитационного показателя</p>
                  <ul>{options.map((i) => <li>{i}</li>)}</ul>
                </ReactTooltip>
                <Check
                  className={styles.checkBlock}
                  mode={score >= max ? `complete` : score <= min ? `notComplete` : `middle`}
                />
              </div>
              <p>{score}</p>
              <p>баллов</p>
              <p>аккредитационного</p>
              <p>показателя</p>
            </div>
          </section>
          <section className={styles.secondSection}>
            <div>
              <Input
                placeholder='поиск'
                onChange={(fio) => setFilters({...filters, fio})}
              />
              <Select
                value={filters.order_by}
                onChange={(e) => setFilters({...filters, order_by: e.target.value})}
              >
                <option selected hidden>Сортировать по</option>
                <option value='fio'>ФИО</option>
                <option value='percent'>Процент выполнения</option>
                <option value='faculty'>Факультет</option>
                <option value='group'>Группа</option>
              </Select>
              <div 
                className={styles.sortIcon}
                onClick={() => setFilters({...filters, sort_order: filters.sort_order === 'asc' ? 'desc' : 'asc'})}
              >
                {filters.sort_order === 'asc' ? <PiSortAscending /> : <PiSortDescending />}
              </div>
            </div>
            <div>
              {!!students?.length && <ul>{students?.map((user, ind) => <User key={ind} user={user} />)}</ul>}
              {!students?.length && <div className={styles.noData}>Данные отсутствуют</div>}
            </div>
          </section>
          <section className={styles.thirdSection}>            
            <Chart data={bins}/>
          </section>
        </div>
      </section>
    </div>
  )
}


const User = ({user}) => {
  
  const {fio, group_name, avg_percent, mid} = user
  
  const dispatch = useDispatch()
  
  const [photo, setPhoto] = useState('')
  
  useEffect(async () => {
    const photoUrl = await dispatch(getPhoto(mid))
    setPhoto(photoUrl)
  }, [user])
  
  
  return (
    <li className={styles.userBlock}>
      <div>
        {photo ? <img src={photo} alt="photo" /> : <IoPerson size={50} color='#5c76e3'/>}
      </div>
      <div>
        <p>{fio}</p>
        <p>{group_name}</p>
      </div>
      <div>
        <img src={progress} alt="experience" />
        <div style={{marginTop: '5px'}}>
          <p>
            {avg_percent}
            <span style={{fontSize: '1rem'}}>%</span>
          </p>
        </div>
      </div>
    </li>
)}


const PieChartComponent = ({percentage}) => {
  
  const step = 0.5;
  const countSteps = Math.round(percentage / step);

  const gradientData = Array.from({ length: countSteps }, (_, i) => {
    const hue = 120 * percentage / 100 * (1 - (countSteps - i) / countSteps)
    const color = `hsl(${hue}, 100%, 50%)`;
    return { value: step, color };
  });

  const pieData = [
    ...gradientData,
    { value: 100 - percentage, color: '#fff' },
  ];


  return (
    <ResponsiveContainer width={200} height={200} style={{ margin: '0 auto', display: 'block' }}>
      <PieChart>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          innerRadius={40}   
          outerRadius={60}   
          // fill="#5B76E5"
          dataKey="value"
          nameKey="name"
          stroke='none'
          // label
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
          ))}
        </Pie>
        <text
          x="50%"
          y="52%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="25"
          fontWeight="bold"
          // fill="#5B76E5"
        >
          {percentage}%
        </text>
        {/* <Tooltip /> */}
        {/* <Legend /> */}
      </PieChart>
    </ResponsiveContainer>
  )
}


const Chart = ({ data }) => {
  
  const getTicksRange = (data, field) => {
    const maxY = data?.length > 0 ? Math.max(...data.map(item => item[field])) : 0;
    const maxTick = Math.ceil(maxY) + 1; // или maxY + 1, если maxY — целое
    return Array.from({ length: maxTick + 1 }, (_, i) => i);
  }

  const yTicks = getTicksRange(data, 'count');
  
  const RoundedBar = (props) => {
    const { fill, x, y, width, height, radius = 5 } = props;

    // Если высота 0 или отрицательная — не рисуем
    if (height <= 0) {
      return null;
    }

    // Путь для прямоугольника со скруглёнными ВЕРХНИМИ углами
    return (
      <path
        d={[
          `M ${x} ${y + height}`, // начальная точка — низ слева
          `H ${x + width}`,       // горизонталь вправо
          `V ${y + radius}`,      // вверх до начала скругления
          `Q ${x + width} ${y}, ${x + width - radius} ${y}`, // верхний правый угол
          `H ${x + radius}`,      // горизонталь влево
          `Q ${x} ${y}, ${x} ${y + radius}`, // верхний левый угол
          `V ${y + height}`,      // вниз до низа
          'Z',                    // замкнуть
        ].join(' ')}
        fill={fill}
      />
    );
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ bottom: 30, left: 30 }}>
        <defs>
          {data?.map((_, ind) => {
            const color1 = (120 * (ind + 1)) / data.length
            const color2 = (120 * ind) / data.length
            return (
              <linearGradient id={`gradient${ind}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={`hsl(${color1}, 100%, 50%)`} />
                <stop offset="100%" stopColor={`hsl(${color2}, 100%, 50%)`} />
              </linearGradient>
            )
          })}
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="label"
          label={{
            value: 'выполнено заданий',
            position: 'insideBottom',
            offset: -10,
            fontWeight: 'bold',
            style: {
              fontSize: '12px',
              fill: '#000', // цвет текста в SVG (используется fill, а не color)
            },
          }}
        />
        <YAxis
          ticks={yTicks}
          label={{
            value: 'кол-во курсантов/слушателей',
            angle: -90,
            position: 'insideLeft',
            dx: -10,
            dy: 0,
            fontWeight: 'bold',
            style: {
              fontSize: '12px',
              fill: '#000',
              textAnchor: 'middle',
            },
          }}
        />
        <Tooltip />
        <Bar shape={< RoundedBar radius={12} />} dataKey="count" barSize={100} name='Количество'>
          <LabelList
            dataKey="count"
            position="top"
            fill="grey"
            fontSize={16}
            fontWeight="bold"
          />
          {data?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={`url(#gradient${index})`} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}


export default Details